import {
  FileText, Newspaper, PenTool, Image, Video, Film, Mic, Music, Camera, BookOpen, Feather, Type,
  Instagram, Youtube, Twitter, Facebook, Linkedin, Share2, Hash, AtSign, MessageCircle, ThumbsUp,
  Circle, Clock, Hourglass, CheckCircle2, ListChecks, Flag, Target, Rocket, Send, Inbox, Archive, Eye, Sparkles, Zap,
  Calendar, LayoutGrid, Columns, ClipboardList, Pin, Bookmark, FolderOpen, Folder, Tag, Tags,
  Star, Heart, Bell, AlertTriangle, Flame, TrendingUp, Award, Crown, Gem,
  Coffee, Lightbulb, Palette, Brush, Globe, Compass, Map, Layers, Package, Briefcase, Wrench, Settings, Search, Filter,
} from "lucide-react";

// Curated Lucide set for organisation appearance (icons only — no emoji, no
// arbitrary SVG). Grouped for the picker; a single flat map powers rendering.
export const ICON_GROUPS = [
  { label: "Content", names: ["FileText", "Newspaper", "PenTool", "Type", "Feather", "BookOpen", "ClipboardList"] },
  { label: "Media", names: ["Image", "Video", "Film", "Camera", "Mic", "Music"] },
  { label: "Social", names: ["Instagram", "Youtube", "Twitter", "Facebook", "Linkedin", "Share2", "Hash", "AtSign", "MessageCircle", "ThumbsUp"] },
  { label: "Workflow", names: ["Circle", "Clock", "Hourglass", "CheckCircle2", "ListChecks", "Eye", "Send", "Inbox", "Archive", "Flag", "Target", "Rocket"] },
  { label: "Planning", names: ["Calendar", "LayoutGrid", "Columns", "Layers", "FolderOpen", "Folder", "Tag", "Tags", "Pin", "Bookmark"] },
  { label: "Accent", names: ["Star", "Heart", "Bell", "Sparkles", "Zap", "Flame", "TrendingUp", "Award", "Crown", "Gem", "AlertTriangle"] },
  { label: "Misc", names: ["Lightbulb", "Coffee", "Palette", "Brush", "Globe", "Compass", "Map", "Package", "Briefcase", "Wrench", "Settings", "Search", "Filter"] },
];

export const ICON_MAP = {
  FileText, Newspaper, PenTool, Image, Video, Film, Mic, Music, Camera, BookOpen, Feather, Type,
  Instagram, Youtube, Twitter, Facebook, Linkedin, Share2, Hash, AtSign, MessageCircle, ThumbsUp,
  Circle, Clock, Hourglass, CheckCircle2, ListChecks, Flag, Target, Rocket, Send, Inbox, Archive, Eye, Sparkles, Zap,
  Calendar, LayoutGrid, Columns, ClipboardList, Pin, Bookmark, FolderOpen, Folder, Tag, Tags,
  Star, Heart, Bell, AlertTriangle, Flame, TrendingUp, Award, Crown, Gem,
  Coffee, Lightbulb, Palette, Brush, Globe, Compass, Map, Layers, Package, Briefcase, Wrench, Settings, Search, Filter,
};

export const ALL_ICON_NAMES = Object.keys(ICON_MAP);

// Render a configured icon by name. Returns null when no icon is set / unknown,
// so callers can safely spread it into chips/headers.
export function AppIcon({ name, className = "h-4 w-4", style }) {
  const Cmp = name && ICON_MAP[name];
  if (!Cmp) return null;
  return <Cmp className={className} style={style} />;
}
